import type { Forecast } from '../../adapters/forecast-http';
import type { RegionalEvidence } from '../../adapters/regional-http';

// Stable, mode-scoped identities survive the backend's polling revisions.
export const stationSelection = (sourceId: string) => `station:LIVE:${sourceId}`;
export const gridSelection = (f: Pick<Forecast, 'sourceMode' | 'region' | 'gridIdentity'>) =>
  `grid:${f.sourceMode}:${f.region.regionId}:${f.gridIdentity}`;
export function evidenceSelected(e: RegionalEvidence, selected: string) {
  if (selected === e.id || selected === e.sourceId) return true;
  if (e.kind === 'STATION_OBSERVATION' && e.mode === 'LIVE')
    return selected === stationSelection(e.sourceId);
  return (
    e.kind === 'GRID_WEATHER_FORECAST' &&
    selected === `grid:${e.mode}:${e.regionId}:${e.sourceRecordId}`
  );
}
